// extracted by mini-css-extract-plugin
module.exports = {"small":"VerticalMargin_small__xmydr","medium":"VerticalMargin_medium__9IXVT","large":"VerticalMargin_large__2A6HO","extralarge":"VerticalMargin_extralarge__v_gcs"};